exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pagination a{color:#fff!important}.dropdown-item{cursor:pointer}@media (max-width:1258px){.pagination-link-btn:first-child,.pagination-link-btn:last-child{display:none}.pagination-link-btn:nth-child(2){border-top-left-radius:5px!important;border-bottom-left-radius:5px!important}.pagination-link-btn:nth-last-child(2){border-top-right-radius:5px!important;border-bottom-right-radius:5px!important}}@media (max-width:576px){.hide-not-focused-btn:not(.focus){display:none}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-41b44703","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/tables/vuetable-2/DataTable.vue
// module id = 554
// module chunks = 27